/**
 cate and subcate data store
 */
import Vue from 'vue';
import Vuex from 'vuex';
import * as i18n from '@js/i18n';
Vue.use(Vuex);

export const mainSite = {
    namespaced: true,
    state: {
        logo:null,
        relationLang:null,
        relation:null,
        theme:'theme1', //for theme name setting. default is theme1 if not provided
        relationURL: "",
        defaultRelationURL: "",
        mobile_logo: null
    },
    mutations: {
        setLogo(state, payload) {
            state.logo = "/" + payload;
        },
        setMobileLogo(state, payload)
        {
            state.mobile_logo = "/" + payload;

        },
        setTheme(state, payload) {
            state.theme = payload;
        },
        setRelationLang(state, payload) {
            state.relationLang = payload;
        },
        setRelation(state, payload) {
            if (payload !== null &&  payload !== ""  &&  payload !== undefined) {
                state.relation = payload;
            }
        },
        setRelationURL(state, payload) {
            state.relationURL = payload;
        },
        setDefaultRelationURL(state, payload) {
            state.defaultRelationURL = payload;
        }

    },
    getters: {
        getRelatedLangStr: state => {
            if (state.relationLang === "en") {
                return "ENG";
            } else {
                return "中文"; //if 'zh' or not set, 出'中文'
            }
        },
        getRelationURL: state =>
        {
            return state.relationURL.replace("hkep-lom:", "");
        },
        getDefaultRelationURL: state =>
        {
            return state.defaultRelationURL;
        }
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/mainSite.js